import { __exports as u } from "../../../_virtual/isFullWidth.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(u, "__esModule", {
  value: !0
}), u.default = function (u) {
  return (0, e.default)(u), l.test(u);
}, u.fullWidth = void 0;
var e = t && t.__esModule ? t : {
    default: t
  },
  l = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
u.fullWidth = l;